import { Bar } from '@ant-design/charts';
import { useContext } from 'react';
import { Empty } from 'antd';
import { orderBy } from 'lodash';
import { BarConfig } from '@ant-design/charts/es';
import { TssDataContext } from '../../contexts/TssDataContext';
import { getTssCategory, getTssColor } from '../../utils/chartUtils';

type TeamType = 'Engagement' | 'Team';

interface IProps {
  type: TeamType;
}

export const TssColumn = ({ type }: IProps) => {
  const { engagmentActuals, teamActuals } = useContext(TssDataContext);

  const actualsNotNull =
    type === 'Engagement'
      ? engagmentActuals?.filter((item) => item.tss != null)
      : teamActuals?.filter((item) => item.tss != null);

  if (!actualsNotNull?.length) {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
  }

  let data = orderBy(actualsNotNull, (item) => item.tss, 'asc').map((item) => ({
    value: item.tss,
    label: item.name,
    category: getTssCategory(item.tss),
  }));

  const handleBarClicked = (_, event) => {
    if (event.type !== 'axis-label:click') {
      return;
    }

    const target: any = event.target;
    const team = actualsNotNull.find((x) => x.name === target.attrs.text);

    window.open(`/${type === 'Engagement' ? type : 'project'}/${team.teamId}`);
  };

  var config: BarConfig = {
    height: 600,
    seriesField: 'category',
    yField: 'label',
    xField: 'value',
    color: ({ category }) => {
      const label = category.split(' (')[0];
      return getTssColor(label);
    },
    label: {},
    data,
    legend: {
      position: 'top',
      flipPage: false,
    },
    xAxis: { label: { autoRotate: true } },
    scrollbar: {
      type: 'vertical',
    },
    onEvent: handleBarClicked,
  };

  return <Bar {...config} />;
};
